import type { Role } from '../api/types';

export type SettingsTab = 'account' | 'appearance' | 'ai' | 'network' | 'homepage' | 'about';

export const settingsTabs: { id: SettingsTab; label: string; permission?: 'owner' | 'operate' }[] = [
  { id: 'account', label: 'アカウント' },
  { id: 'appearance', label: '表示' },
  { id: 'ai', label: 'AI 連携' },
  { id: 'network', label: 'サーバー共通', permission: 'operate' },
  { id: 'homepage', label: 'ホームページ', permission: 'owner' },
  { id: 'about', label: 'このパネルについて' },
];

/** 検索の focus（data-search-id）から、その項目があるタブを決める。先頭一致 */
const focusPrefixes: [prefix: string, tab: SettingsTab][] = [
  ['appearance', 'appearance'],
  ['account', 'account'],
  ['sftp', 'account'],
  ['discord', 'account'],
  ['mcp-policy', 'ai'],
  ['tokens', 'ai'],
  ['oauth', 'ai'],
  ['network-ip-bans', 'network'],
  ['shared-database', 'network'],
  ['homepage', 'homepage'],
  ['about', 'about'],
  ['auto-update', 'about'],
  ['agent-update', 'about'],
  ['launcher-download', 'about'],
];

export function settingsTabForFocus(focus: string | null | undefined): SettingsTab | undefined {
  if (!focus) return undefined;
  return focusPrefixes.find(([prefix]) => focus === prefix || focus.startsWith(`${prefix}-`))?.[1];
}

export function visibleSettingsTabs(role: Role | undefined) {
  return settingsTabs.filter(
    (tab) => !tab.permission || (tab.permission === 'owner' ? role === 'owner' : role === 'owner' || role === 'admin'),
  );
}

export function resolveSettingsTab(params: URLSearchParams, role: Role | undefined): SettingsTab {
  const visible = visibleSettingsTabs(role);
  const requested = params.get('tab') ?? settingsTabForFocus(params.get('focus'));
  return visible.find((tab) => tab.id === requested)?.id ?? visible[0]!.id;
}
